import React from 'react';
import { TranslatedMessage } from 'common/components/Intl';
import IconInfo from '!svg-react-loader?!images-react-svg/icons/icon-info.svg';

const PurchaseOptionsTooltip = () => {
  const tooltipTextGroups = [
    [
      'cart.quick_shop.dual_cta.tooltip.auto_ship_title',
      'cart.quick_shop.dual_cta.tooltip.auto_ship_text',
    ],
    [
      'cart.quick_shop.dual_cta.tooltip.one_time_title',
      'cart.quick_shop.dual_cta.tooltip.one_time_text',
    ],
  ];

  return (
    <legend>
      <TranslatedMessage id="cart.quick_shop.dual_cta.purchase_options" />
      <div className="tooltip PurchaseOptions__tooltip">
        <IconInfo />
        <span className="quickShop__tooltip tooltip__text text--body--small">
          {tooltipTextGroups.map((group, i) => (
            <div className="text--body--small quickShop__tooltip__text" key={i}>
              {group.map((translationKey, j) => (
                <TranslatedMessage id={translationKey} key={j} />
              ))}
            </div>
          ))}
        </span>
      </div>
    </legend>
  );
};

export default PurchaseOptionsTooltip;
